export default "__VITE_ASSET__8cab5a50__"